import { getType } from 'typesafe-actions';
import { actions } from '..';
import { Actions, StoreState } from '../types';

export function now(state: number = 0, action: Actions) {
  if (action.type === getType(actions.setNow)) {
    return action.payload
  }
  return state
}

export function getNow(state: StoreState) {
  return state.now
}

export function idleSeconds(state: number = 0, action: Actions) {
  if (action.type === getType(actions.setIdleSeconds)) {
    return action.payload
  }
  return state
}
